import EventEmitter, { EVENT_TYPES } from './eventEmitter';
import request from 'superagent';
import { snakeCaseKeys } from '@utils';

export default function FinanceRequest() {
  const state = {
    annualMileage: null,
    deposit: null,
    term: null,
  };

  const _HTTPError = () => {
    return {
      event: 'GAEvent',
      eventCategory: 'Finance',
      eventAction: 'PCP Calculator Request',
      eventLabel: 'HTTP Error',
      financeType: 'Calculated PCP',
      financeTerm: state.term,
      financeAnnualMileage: state.annualMileage,
      financeDeposit: state.deposit,
    };
  };

  const _failedQuote = () => {
    return {
      event: 'GAEvent',
      eventCategory: 'Finance',
      eventAction: 'PCP Calculator Request',
      eventLabel: 'Failed to calculate quote',
      financeType: 'Calculated PCP',
      financeTerm: state.term,
      financeAnnualMileage: state.annualMileage,
      financeDeposit: state.deposit,
    };
  };

  const _successQuote = (response) => {
    return {
      event: 'GAEvent',
      eventCategory: 'Finance',
      eventAction: 'PCP Calculator Request',
      eventLabel: 'Success',
      financeType: 'Calculated PCP',
      financeTerm: state.term,
      financeAnnualMileage: state.annualMileage,
      financeDeposit: state.deposit,
      financeMonthlyPayment: response.body.data.monthlyPayment
        ? response.body.data.monthlyPayment.value
        : 0,
      financeFutureValue: response.body.data.guaranteedFutureValue
        ? response.body.data.guaranteedFutureValue.value
        : 0,
    };
  };

  const _pcpUpdateFailedHTTPError = () => {
    dataLayer.push(_HTTPError());
    EventEmitter.emit(
      EVENT_TYPES.failedPcpUpdate,
      'Unable to fetch PCP quote at this time. Please try again later.'
    );
  };

  const _pcpUpdateFailed = (response) => {
    dataLayer.push(_failedQuote());
    EventEmitter.emit(EVENT_TYPES.failedPcpUpdate, response.body.errors);
  };

  const _pcpUpdateSuccess = (response) => {
    dataLayer.push(_successQuote(response));
    EventEmitter.emit(EVENT_TYPES.calculatedPcpUpdate, response.body.data);
  };

  const _pcpResponse = (err, response) => {
    if (err) return _pcpUpdateFailedHTTPError();
    if (response.body.errors) return _pcpUpdateFailed(response);
    return _pcpUpdateSuccess(response);
  };

  const _hpResponse = (_errors, _response) => {
    const response = _response.body;
    if (response.errors) {
      return EventEmitter.emit(EVENT_TYPES.failedHpUpdate, [
        response.errors[0].detail,
      ]);
    }

    return EventEmitter.emit(EVENT_TYPES.calculatedHpUpdate, response.data);
  };

  const pcpRequest = (postData) => {
    const snakeCasedPostData = snakeCaseKeys(postData);
    state.term = postData.term;
    state.deposit = postData.deposit;
    state.annualMileage = postData.annual_mileage;
    EventEmitter.emit(EVENT_TYPES.requestedPcpUpdate);
    request
      .post('/api/pcp_finance')
      .send(snakeCasedPostData)
      .set('Accept', 'application/json')
      .end(_pcpResponse);
  };

  const hpRequest = (postData) => {
    const snakeCasedPostData = snakeCaseKeys(postData);
    state.term = postData.term;
    state.deposit = postData.deposit;
    state.annualMileage = null;
    request
      .get(`/vehicles/${postData.stockReference}/hp_finance.json`)
      .query(snakeCasedPostData)
      .end(_hpResponse);
  };

  return {
    hpRequest,
    pcpRequest,
  };
}
